

export const BicycleCard=()=>{
    
    return(
        <div className="bicyle-card">
            <div className='bicyle-card_row'>
                <img src={require('../../static/frame-icon.png')}/>
                <h2 className='bicyle-card_header'>
                    VINTAGE OLIVA
                </h2>
                <span className='bicyle-card_text'>
                    Lorem Ipsum is simply dummy text of the printing and typesetting industry. Lorem Ipsum has been the industry's standard dummy text ever since the 1500s, when an unknown printer took a galley of type and scrambled it to make a type specimen book. It has survived.
                </span>
                <div className='bicyle-card_line'>

                </div>
            </div>
        </div>
    )
}